import { Organization } from "../Organization";

export class MockOrganization implements Organization {
  subscriptionMessage?: string;
  subscriptionUrl?: string;
  supportUrl?: string;
  gamepadUrl?: string;
  faqUrl?: string;
  name: string;
  constructor() {
    this.name = "mock;";
  }
}
